var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiTreeView from '@material-ui/lab/TreeView';
import { DownCaretIcon, RightCaretIcon } from '../Icon';
/**
 * Kareo wrapped component of the Material-UI Tree View. The prop API has been limited to props defined in TreeViewProps.
 *
 * A tree view widget presents a hierarchical list.
 *
 * Material-UI TreeView: [Tree View](https://v4.mui.com/components/tree-view/), [API](https://v4.mui.com/api/tree-view/)
 *
 * @storybook: [TreeView](http://design.kareoprod.ent/?path=/story/design-system_components-data-display-treeview--basic)
 */
var TreeView = React.forwardRef(function (props, ref) {
    return (React.createElement(MuiTreeView, __assign({}, props, { ref: ref, defaultCollapseIcon: React.createElement(DownCaretIcon, null), defaultExpandIcon: React.createElement(RightCaretIcon, null) })));
});
TreeView.displayName = 'KareoTreeView';
export default TreeView;
